require('./hireCardOpenYoungSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ constants
const { OPENYOUNG_CARD_ACCIDENT_INSURANCE } = require('constants/links');
const { catalogue, analyticsId } = require('../analytics/hireCardOpenYoungAnalytics');

class HireCardOpenYoungSuccess extends React.Component {

    buildUploadDocumentationSection() {
        const { immHireCardOpenYoung  } = this.props;

        let uploadDocumentation;

        if (!!immHireCardOpenYoung.get('cardId')) {
                const addDocumentationLink = `/myprofile/cards/${immHireCardOpenYoung.get('cardId')}/upload-documentation`;

            uploadDocumentation = (
                <div className="hire-card-open-young-success__upload-documentation-wrapper">
                    <p className="hire-card-open-young-success__upload-documentation">
                        <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_uploadDocumentationText" />
                    </p>
                    <OKButton
                        modifier="secondary"
                        to={addDocumentationLink}
                    >
                        <FormattedText value="hireCardOpenYoung-hireCardOpenYoung_uploadDocumentationButton" />
                    </OKButton>
                </div>
            );
        }

        return uploadDocumentation;
    }

    render() {
        const {
            immAccount,
            immHireCardImageSelector,
            immOpenYoungPersonalData,
            immProfile,
            processDetail
        } = this.props;

        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const accountIban = getLastNChars(immAccount.get('iban'));
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardOpenYoung-hireCardOpenYoung_successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };
            const minorName = immOpenYoungPersonalData.getIn(['name', 'value']);
            const uploadDocumentation = this.buildUploadDocumentationSection();
            content = (
                <WizardSuccess
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText('hireCardOpenYoung-hireCardOpenYoung_successTitleCompleted', [minorName])}
                    tealium={catalogue[analyticsId.OPEN_YOUNG_CARD_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-card-open-young-success">
                        <div className="row">
                            <div className="col-xs-6">
                                <OKInformativeList columns={1}>
                                    <OKInformativeListItem>
                                        <HireSuccessStepCardImage
                                            className="hire-card-open-young-success__card-image"
                                            immImageData={immImageData}
                                        />
                                    </OKInformativeListItem>
                                </OKInformativeList>
                            </div>
                            <div className="col-xs-6">
                                {uploadDocumentation}
                            </div>
                            <div className="col-xs-12">
                                <OKInformativeList columns={1}>
                                    <OKInformativeListItem
                                        title="hireCardOpenYoung-hireCardOpenYoung_successAssociatedAccount"
                                        bodyText={`${immAccount.get('alias')} ${accountIban}`}
                                        isUppercaseTitle={true}
                                    />
                                </OKInformativeList>
                            </div>
                        </div>
                        <React.Fragment>
                            <div className="hire-card-open-young-success__download-instruction">
                                <FormattedText
                                    value="contractsView-openyoungAppDownloadInfo"
                                    className="hire-card-open-young-success__title"
                                    injectedStrings={[minorName]}
                                />
                            </div>
                            <div>
                                <div className="hire-card-open-young-success__text-message">
                                    <OKMessage type="informative">
                                        <FormattedText value="contractsView-openyoungDocumentFirst" />
                                    </OKMessage>
                                </div>
                                <div className="hire-card-open-young-success__text-message">
                                    <OKMessage type="informative">
                                        <OKLink
                                            to={OPENYOUNG_CARD_ACCIDENT_INSURANCE}
                                            target="_blank"
                                            modifier="inline"
                                            >
                                            <FormattedText value="contractsView-openyoungDocumentSecond" />
                                        </OKLink>
                                    </OKMessage>
                                </div>
                            </div>
                        </React.Fragment>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HireCardOpenYoungSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardOpenYoung: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    processDetail: PropTypes.string,
};

module.exports = HireCardOpenYoungSuccess;
